module.exports = __webpack_public_path__ + "6196f1198f32d7dcbd5b26abf16934f4.pdf";